<template>
  <div class="copyright-application dark-theme">
    <!-- 顶部横幅 -->
    <div class="hero-banner">
      <div class="container">
        <h1 class="hero-title">{{ $t('_bqyy._spsq') }}</h1>
        <p class="hero-subtitle">{{ $t('_bqyy._spsy') }}</p>
      </div>
    </div>

    <div class="container">
      <!-- 主要内容区域 -->
      <div class="content-wrapper">
        <!-- 左侧内容 -->
        <div class="main-content">
          <!-- 驳回消息 -->
          <section class="content-section" style="" v-if="info.status == 1">
            <h2 class="section-title" style="border-left: 4px solid #4caf50; color: #4caf50; margin-bottom: 0">{{ $t('_bq._zzsqz') }}</h2>
          </section>
          <!-- 驳回消息 -->
          <section class="content-section" style="border: 2px dashed #ff0000" v-if="info.status == 3">
            <h2 class="section-title" style="border-left: 4px solid #ff0000; color: #ff4444;">{{ $t('_sq._bhbt') }}</h2>
            <div class="section-content">
              <div style="font-weight: bold; color: #ff6b6b;">{{ $t('_sq._bhyy') }}</div>
              <p style="color: #cccccc;">{{ info.reason }}</p>
            </div>
          </section>

          <!-- 什么是影片版权合作 -->
          <section class="content-section">
            <h2 class="section-title">{{ $t('_bqyy._sphz') }}</h2>
            <div class="section-content">
              <p>{{ $t('_bqyy._sphzsm') }}</p>
            </div>
          </section>

          <!-- 申请好处 -->
          <section class="content-section">
            <h2 class="section-title">{{ $t('_bqyy._sqhch') }}</h2>
            <div class="benefits-grid">
              <div class="benefit-card">
                <div class="benefit-icon">📈</div>
                <h3>{{ $t('_bqyy._llfz') }}</h3>
                <p>{{ $t('_bqyy._llfzsm') }}</p>
              </div>
              <div class="benefit-card">
                <div class="benefit-icon">💰</div>
                <h3>{{ $t('_bqyy._sytg') }}</h3>
                <p>{{ $t('_bqyy._sytgsm') }}</p>
              </div>
              <div class="benefit-card">
                <div class="benefit-icon">⭐</div>
                <h3>{{ $t('_bqyy._yxhz') }}</h3>
                <p>{{ $t('_bqyy._yxhzsm') }}</p>
              </div>
            </div>
          </section>

          <!-- 预约条件 -->
          <section class="content-section">
            <h2 class="section-title">{{ $t('_bqyy._yytj') }}</h2>
            <div class="requirements">
              <div class="requirement-item">
                <div class="requirement-number">1</div>
                <div class="requirement-content">
                  <h3>{{ $t('_bqyy._sptg') }}</h3>
                  <p>{{ $t('_bqyy._sptgsm') }}</p>
                </div>
              </div>
            </div>
          </section>
          <!-- 输入内容 -->
          <section class="content-section">
            <h2 class="section-title">{{ $t('_bq._sqbz') }}</h2>
            <a-textarea v-model:value="content" style="border-radius: 15px; height: 150px" :placeholder="$t('_bq._sqbzsm')" />
          </section>
          <!-- 底下卡片 -->
          <div class="sidebar">
            <div class="reserve-card">
              <div class="reserve-header">
                <h3>{{ $t('_bqyy._ljyy') }}</h3>
                <p class="reserve-desc">{{ $t('_bqyy._yysm') }}</p>
              </div>
              <button class="reserve-card-btn" @click="showReservationForm = true">{{ $t('_bqyy._ljyy') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 预约表单弹窗 -->
    <ReservationForm v-if="showReservationForm" @close="showReservationForm = false" @submit="apply" />
  </div>
</template>

<script>
import ReservationForm from '@/components/apply/ReservationForm.vue'
import E from 'wangeditor'
export default {
  name: 'CopyrightApplication',
  components: {
    ReservationForm
  },
  data() {
    return {
      showReservationForm: false,
      info: {},
      content: '',
      editor: null
    }
  },
  created() {
    this.getApply()
  },
  mounted() {
    // this.initEditor()
  },
  methods: {
    initEditor() {
      this.editor = new E(this.$refs.editorRef)
      this.editor.config.menus = [
        'head', 'bold', 'fontSize', 'fontName', 'italic', 'underline',
        'strikeThrough', 'foreColor', 'backColor', 'link', 'list',
        'justify', 'quote', 'emoticon', 'table', 'code', 'undo', 'redo'
      ]
      this.editor.config.onchange = (newHtml) => {
        this.content = newHtml
      }
      this.editor.config.placeholder = this.$t('_bq._sqbzsm') + '...'
      this.editor.config.uploadImgServer = '/api/upload'
      this.editor.config.uploadFileName = 'file'
      this.editor.config.uploadImgMaxSize = 2 * 1024 * 1024
      this.editor.config.uploadImgMaxLength = 5
      this.editor.config.customUploadImg = (files, insertImgFn) => {
        const file = files[0]
        const reader = new FileReader()
        reader.onload = (e) => {
          insertImgFn(e.target.result)
          // this.$message.success('图片上传成功')
        }
        reader.readAsDataURL(file)
      }
      this.editor.create()
    },
    getApply() {
      let that = this
      this.$api.userApply.getApply().then((res) => {
        that.info = res.data
      })
    },
    apply(form) {
      console.log('form', form)
      this.$message.loading({ content: 'applying', key: 'msg' })
      let that = this
      this.$api.userApply
        .apply({ content: this.content })
        .then((res) => {
          that.showReservationForm = false
          if (res.code == 1) {
            that.$message.warning({ content: res.msg, key: 'msg' })
            return
          }
          that.$message.success({ content: res.msg, key: 'msg' })
        })
        .catch((res) => {
          that.showReservationForm = false
          that.$message.warning({ content: res.msg, key: 'msg' })
        })
    }
  }
}
</script>

<style scoped>
/* ===== 深色主题 ===== */
.dark-theme {
  background: #0b0d0f;
  min-height: 100vh;
}

.dark-theme .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ===== 顶部横幅 ===== */
.dark-theme .hero-banner {
  background: linear-gradient(135deg, #1a1a2e, #16213e, #0f3460);
  color: white;
  padding: 80px 0;
  text-align: center;
  border-bottom: 1px solid #2a3038;
}

.dark-theme .hero-title {
  color: #e8edf2;
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.dark-theme .hero-subtitle {
  color: #b0bcc8;
  font-size: 1.3rem;
  margin-bottom: 40px;
  opacity: 0.9;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/* ===== 主要内容区域 ===== */
.dark-theme .content-wrapper {
  display: grid;
  gap: 40px;
  padding: 60px 0;
}

/* ===== 内容区块 ===== */
.dark-theme .content-section {
  background: #1a1f26;
  border-radius: 15px;
  padding: 40px;
  margin-bottom: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  border: 1px solid #2a3038;
}

.dark-theme .section-title {
  font-size: 1.8rem;
  color: #e8edf2;
  margin-bottom: 25px;
  border-left: 4px solid #ffb300;
  padding-left: 15px;
}

.dark-theme .section-content {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #b0bcc8;
}

.dark-theme .section-content p {
  color: #b0bcc8;
}

/* ===== 好处网格 ===== */
.dark-theme .benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin-top: 30px;
}

.dark-theme .benefit-card {
  text-align: center;
  padding: 30px 20px;
  background: #0a0d0f;
  border-radius: 10px;
  transition: transform 0.3s ease;
  border: 1px solid #2a3038;
}

.dark-theme .benefit-card:hover {
  transform: translateY(-5px);
  border-color: #ffb300;
}

.dark-theme .benefit-icon {
  font-size: 3rem;
  margin-bottom: 15px;
}

.dark-theme .benefit-card h3 {
  color: #e8edf2;
  margin-bottom: 15px;
  font-size: 1.3rem;
}

.dark-theme .benefit-card p {
  color: #8a949f;
  line-height: 1.6;
}

/* ===== 预约条件 ===== */
.dark-theme .requirements {
  margin-top: 30px;
}

.dark-theme .requirement-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 25px;
  background: #0a0d0f;
  border-radius: 10px;
  border-left: 4px solid #ffb300;
}

.dark-theme .requirement-number {
  background: #ffb300;
  color: #0b0d0f;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}

.dark-theme .requirement-content h3 {
  color: #e8edf2;
  margin-bottom: 8px;
}

.dark-theme .requirement-content p {
  color: #8a949f;
  line-height: 1.6;
}

/* ===== 右侧预约卡片 ===== */
.dark-theme .sidebar {
  position: sticky;
  top: 100px;
  height: fit-content;
}

.dark-theme .reserve-card {
  background: #1a1f26;
  border-radius: 15px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  border: 1px solid #2a3038;
}

.dark-theme .reserve-header h3 {
  color: #e8edf2;
  font-size: 1.5rem;
  margin-bottom: 15px;
}

.dark-theme .reserve-desc {
  color: #8a949f;
  line-height: 1.6;
  margin-bottom: 25px;
}

.dark-theme .reserve-card-btn {
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  border: none;
  padding: 15px 30px;
  font-size: 1.1rem;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  font-weight: 700;
}

.dark-theme .reserve-card-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 179, 0, 0.3);
}

/* ===== 文本域 ===== */
.dark-theme textarea {
  background: #0a0d0f !important;
  border: 1px solid #2a3038 !important;
  color: #e8edf2 !important;
  border-radius: 15px !important;
}

.dark-theme textarea:focus {
  border-color: #ffb300 !important;
  box-shadow: 0 0 0 4px rgba(255, 179, 0, 0.06) !important;
}

.dark-theme textarea::placeholder {
  color: #4a5662 !important;
}

/* ===== 隐藏滚动条 ===== */
.dark-theme {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.dark-theme::-webkit-scrollbar,
.dark-theme *::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

/* ===== 响应式 ===== */
@media (max-width: 1024px) {
  .dark-theme .content-wrapper {
    grid-template-columns: 1fr;
  }
  .dark-theme .sidebar {
    position: static;
  }
}

@media (max-width: 768px) {
  .dark-theme .hero-title {
    font-size: 2.2rem;
  }
  .dark-theme .benefits-grid {
    grid-template-columns: 1fr;
  }
  .dark-theme .content-section {
    padding: 25px;
  }
}

.dark-theme .editor-container {
  border: 1px solid #2a3038;
  border-radius: 4px;
  z-index: 100 !important;
  background: #0a0d0f;
}

.dark-theme .preview {
  padding: 20px;
  border: 1px solid #2a3038;
  border-radius: 4px;
  min-height: 200px;
  background-color: #0a0d0f;
  color: #e8edf2;
}
</style>